<div class="absolute inset-0 overflow-y-auto p-3 sm:p-4 lg:p-6">
  <div class="mx-auto w-full max-w-5xl flex flex-col gap-4">
    <h1 class="text-xl sm:text-2xl xl:text-3xl font-bold tracking-tight text-gray-900">Mein Profil</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 items-start">

    <!-- Personal data -->
    <div class="bg-white shadow-sm rounded-lg border border-gray-100 p-4">
      <h2 class="text-base font-bold text-gray-800 tracking-tight mb-3">Persönliche Daten</h2>
      <label class="block text-sm font-bold text-gray-700 mb-2 tracking-tight" for="name">Name</label>
      <input name="name" id="name" disabled type="text"
             class="block w-full px-3 py-2.5 rounded-lg border border-gray-200 bg-gray-50 text-gray-700 shadow-sm sm:text-sm"
             [ngModel]="authenticationService.userValue?.name">
    </div>

    <!-- Login & authentication -->
    @if (authenticators; as auth) {
    <div class="bg-white shadow-sm rounded-lg border border-gray-100 p-4">
      <h2 class="text-base font-bold text-gray-800 tracking-tight mb-3">Anmeldung &amp; Authentifizierung</h2>

      <p class="text-sm font-bold text-gray-700 mb-2">Externe Authentifizierung</p>
      @if (auth.authenticators.length) {
      <ul class="divide-y divide-gray-200 rounded-md border border-gray-200">
        <!-- Tracked on the identity id: it is the key the Entfernen button sends, so a row that survives a
             reload is the same authenticator by the only identifier that matters here. -->
        @for (a of auth.authenticators; track a.id) {
        <li class="flex flex-col gap-2 p-3 sm:flex-row sm:items-center sm:justify-between">
          <span class="min-w-0">
            <span class="block text-sm font-medium text-gray-900 truncate">{{ a.email || a.displayName || a.provider }}</span>
            <span class="block text-xs text-gray-500">{{ a.provider }}</span>
          </span>
          <button type="button" (click)="removeAuthenticator(a.id)"
                  class="self-start sm:self-auto rounded-md bg-red-50 px-3 py-1.5 text-sm font-medium text-red-600 hover:bg-red-100">
            Entfernen
          </button>
        </li>
        }
      </ul>
      } @else {
      <p class="text-sm text-gray-500">
        Keine externe Authentifizierung verknüpft.
      </p>
      }

      <!-- The four doors (#279), shared with the management profile and the migration notice.

           This screen offered ONE — Microsoft — while the notice offered four and its footer sent people here
           for them. It also drove the wrong door: an employee whose session had never been claimed went at
           link/start, which attaches an authenticator without handing the legacy login's grants over or
           redeeming an invitation bound to the address. The shared component decides claim-vs-link once. -->
      <auth-account-link-options class="mt-3 block" idPrefix="my-profile-link" layout="inline"
                                 [asEmployee]="true"
                                 (claimed)="onNativeClaimed()"
                                 (failed)="onLinkFailed()"/>

      <div class="mt-5 flex items-center justify-between gap-4 rounded-md border border-gray-200 p-3">
        <span class="min-w-0">
          <span id="password-login-label" class="block text-sm font-medium text-gray-900">Passwort-Login</span>
          <span id="password-login-hint" class="block text-xs text-gray-500">
            Kann nur deaktiviert werden, wenn mindestens eine externe Authentifizierung aktiv ist.
          </span>
        </span>
        <!-- The label wraps only the control and its track; the words sit in the sibling span above, so
             without the explicit association this is announced as an unnamed checkbox. The rule that makes it
             refusable is the description rather than the name — it is what the refusal will be about. -->
        <label class="relative inline-flex cursor-pointer items-center">
          <input type="checkbox" class="peer sr-only" [checked]="auth.passwordLoginEnabled"
                 aria-labelledby="password-login-label" aria-describedby="password-login-hint"
                 (change)="togglePasswordLogin($any($event.target).checked)">
          <span class="h-6 w-11 rounded-full bg-gray-300 after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-all peer-checked:bg-theme-primary-600 peer-checked:after:translate-x-5"></span>
        </label>
      </div>
    </div>
    }

    </div>
  </div>
</div>
